import type {ValueEditorType, ValueEditorTypeOrAlias} from 'shared/value-editors/types';
import type {LogService} from 'core/logging/log.service';


export class ValueEditorAliasesService {
    public static readonly serviceName = 'valueEditorAliasesService';

    private aliases: Map<ValueEditorTypeOrAlias, ValueEditorType> = new Map();

    /*@ngInject*/
    constructor(private logService: LogService) {}

    public addAlias(aliasTypeName: ValueEditorTypeOrAlias, editorType: ValueEditorType) {
        if (this.aliases.has(aliasTypeName)) {
            throw new Error(`Alias '${aliasTypeName}' is already defined`);
        }

        this.aliases.set(aliasTypeName, editorType);
    }

    public removeAlias(aliasTypeName: ValueEditorTypeOrAlias) {
        if (!this.aliases.has(aliasTypeName)) {
            this.logService.warn(`Alias '${aliasTypeName}' not found.`);
        }

        this.aliases.delete(aliasTypeName);
    }

    public getAlias(aliasTypeName: ValueEditorTypeOrAlias): ValueEditorType {
        if (!this.aliases.has(aliasTypeName)) {
            throw new Error(`Alias '${aliasTypeName}' not found.`);
        }

        return this.aliases.get(aliasTypeName);
    }

    public isAlias(aliasTypeName: ValueEditorTypeOrAlias): aliasTypeName is string {
        return this.aliases.has(aliasTypeName);
    }
}
